import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  Spin,
  Button,
  Card,
  Select,
  message,
  Layout,
  Table,
  Modal,
  Drawer,
  Divider,
} from 'antd'
import {
  UserOutlined,
  ArrowLeftOutlined,
  ExpandOutlined,
  CloseOutlined,
  BarChartOutlined,
} from '@ant-design/icons'
import { Redirect, Link } from 'react-router-dom'
import '../../css/signin.scss'
import util from '../../util/util'
import { useParams, useHistory, useLocation } from 'react-router'
import { useEffect, useState, useRef } from 'react'
import {
  verifyActivityLinkOtp,
  validPatientId,
} from '../../store/action/surgeon.action'
import { getRangeExercises } from '../../store/action/exercise.action'
import '../../css/surgeon.page.scss'
import '../../css/activity.scss'
import { useWindowsSize, Home as HomeComponents } from '../../component'
import ActivityGraph from '../../component/graph/activitygraph'
import moment from 'moment'
import { getDeviceSchedule } from '../../store/action/device.action'
import Device from '../../services/device.service'
import _ from 'lodash'
import LineGraph from '../../component/graph/linegraph'
import { getSurveyDetail } from '../../store/action/feedback.action'
import serviceInterface from '../../services/service.interface'
import PatientForm from '../../component/patient/patient.form'
import DeviceGraph from '../../component/patient/forms/devicegraph'
import Oks from '../../component/patient/forms/oks'
import Pain from '../../component/patient/forms/pain'
import Flexion from '../../component/patient/forms/flexion'
import Extension from '../../component/patient/forms/extension'
import TracPatchFlexionChart from '../../component/patient/forms/tracpatch.flexion.chart'
import TracPatchExtensionChart from '../../component/patient/forms/tracpatch.extension.chart'
import TracPatchStepsChart from '../../component/patient/forms/tracpatch.steps.chart'
import TracPatchPainScoreChart from '../../component/patient/forms/tracpatch.painscore.chart'
import ExerciseCompletionLineChart from '../../component/patient/forms/exercise.completion.linechart'
import TracPatchExerciseRepsLine from '../../component/patient/forms/tracpatch.exercise.reps.line'
import { constants } from '../../constants'
import Menubar from '../../component/header/header'
import { getPatient, caregiverNotify, getTracPatchData, getTracpatchExerciseResults } from '../../store/action/patient.action'
import { getRangeMeasurement } from '../../store/action/device.action'
import SessionStorage from '../../util/sessionstore'
import { ShareAltOutlined } from '@ant-design/icons'
import { getFormData } from '../../store/action/patient.action'

import Caregiver from '../caregiver/caregiver'
const session = new SessionStorage()
var device = new Device()
var { BarChart } = HomeComponents

var cardSize =
  (window.innerWidth < window.innerHeight
    ? window.innerWidth
    : window.innerHeight) - 20

cardSize = cardSize < 400 ? cardSize : 400
const { Content, Footer } = Layout

const Activities = (props) => {
  const [state, setState] = useState({
    oks: [],
    pain: [],
    painLevel: [],
    flexion: [],
    extension: [],
  })

  const ref = useRef(null)

  const token = useParams().token
  const patientid = useParams().patientid
  const history = useHistory()
  const location = useLocation()
  const isAdminLite = location.search == constants.ADMIN_LITE

  const CAREGIVER_HISTORY = 'caregiverhistory'

  const size = useWindowsSize()
  const [width, setWidth] = useState(undefined)
  const [patientData, setCaregiver] = useState({})
  const [showActivity, setShowActivity] = useState(false)
  const [patientId, setPatientId] = useState('')
  const [exercisedate, setExercisedate] = useState({
    startdate: moment().subtract(2, 'week').startOf('day').format('MM/DD/YYYY'),
    enddate: moment().endOf('day').format('MM/DD/YYYY'),
  })
  const [exerciserange, setExerciseRange] = useState('2w')
  const [measurementrange, setMeasurementRange] = useState('2w')
  const [deviceid, setDeviceId] = useState(null)
  const [graphData, setGraphData] = useState({})
  const [exercisesArray, setExerciseArray] = useState({
    name: 'Exercises',
    data: [],
  })
  const [surveyDetail, setSurveyDetail] = useState({})
  const [viewGraph, setViewGraph] = useState(false)
  const [formid, setFormId] = useState()
  const [formType, setFormType] = useState()
  const [fullSizeActivity, setFullSizeActivity] = useState(false)
  const [fullScreenMeasurement, setFullScreenMeasurement] = useState(false)
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' &&
      window.innerWidth < constants.MOBILE_MAXWIDTH
  )
  const [formOpen, setFormOpen] = useState(false)
  const [graphOpen, setGraphOpen] = useState(false)
  const [selectedDevice, setSelectedDevice] = useState({})

  const [complianceOpen, setComplianceOpen] = useState(false)
  const [selectedCompliance, setSelectedCompliance] = useState({})

  const [activitySpin, setActivitySpin] = useState(false)
  const [measurementSpin, setMeasurementSpin] = useState(false)
  const [spin, setSpin] = useState(false)

  // TracPatch data — only fetched when the patient has TracPatch on their
  // care plan; renders the latest active ROM test (flexion / extension) and
  // today's step count alongside the existing Vitals rows. Empty by default
  // so non-TracPatch patients see no change.
  const [tracpatchData, setTracpatchData] = useState({ rom: [], steps: [] })

  // TracPatch per-exercise rep results, grouped by exercise — feeds the
  // "% reps completed per day" line charts in the Exercise VIEW modal.
  const [tracpatchExerciseGroups, setTracpatchExerciseGroups] = useState([])

  // Which TracPatch activity (FLEXION / EXTENSION / STEPS) the VIEW button
  // opened, and whether that chart modal is showing.
  const [selectedActivity, setSelectedActivity] = useState(null)
  const [activityOpen, setActivityOpen] = useState(false)

  const [caregiverToken, setCaregiverToken] = useState('')
  const [caregiveremail, setCaregiverEmail] = useState()
  const [shareModal, setShareModal] = useState(false)
  // const[showReportOtp,setShowReportOtp]=useState(false)

  useEffect(() => {
    const patientData = util.verifyToken(token, true)
    setCaregiver(patientData)
    if (token && !_.isEmpty(patientData) && patientData._id) {
      setPatientId(patientData._id)
      setSpin(true)
      ;(async () => {
        await session.setProfile({ token })
        await fetchData(patientData)
      })()
    } else if (props.token && isAdminLite) {
      setShowActivity(true)
      setPatientId(patientid)
      setCaregiver({ _id: patientid })
      setSpin(true)
      ;(async () => {
        await fetchData({ _id: patientid })
      })()
      return
    }
    if (patientid == 'undefined' && patientData?.type != CAREGIVER_HISTORY) {
      // if (patientid=="undefined" && !_.isEmpty(patientData) && patientData.type != CAREGIVER_HISTORY) {
      setShowActivity(true)
    } else {
      //Caregiver flow

      // (async () => {
      //   await  session.setProfile({token})
      //   await  props.fetchPatient(patientData.patientid);
      //   handleActivity(patientid);
      //   setShowActivity(true);
      //   setPatientId(patientid);

      //   await props.getDeviceSchedule(patientid);
      //   const surveyScore = await props.getSurveyDetail(patientid);
      //   if (!_.isEmpty(surveyScore)) setSurveyDetail(surveyScore)
      // })()
      ;(async () => {
        if (patientid && !token && _.isEmpty(patientData)) {
          const data = await props.validPatientId(patientid) //send otp if valid patientid\
          if (!data) {
            history.push('/login')
            return
          }
          if (data.email) setCaregiverEmail(data.email)
          await session.setProfile({ token: data.token })
          setCaregiverToken(data.token)
        } else history.push('/login')
      })()
    }
  }, [])

  useEffect(() => {
    var wdth = ref.current ? ref.current.offsetWidth : 0
    setWidth(wdth)

    function handleResize() {
      setIsMobile(window.innerWidth < constants.MOBILE_MAXWIDTH)
    }

    if (typeof window !== 'undefined') {
      handleResize()
    }

    window.addEventListener('resize', handleResize)
    return () => {
      // remove event listener when the component is unmounted to not cause any memory leaks
      // otherwise the event listener will continue to be active
      window.removeEventListener('resize', handleResize)
    }
  }, [ref.current, size.width, isMobile])

  // Group flat TracPatch rep results into one bucket per exercise, mirroring
  // the grouping in component/patient/forms/tracpatch.exercises.js so each
  // exercise gets its own "% reps completed per day" line chart.
  const groupTracpatchExerciseResults = (records) => {
    const grouped = {}
    ;(records || []).forEach((r) => {
      const key = r.exerciseId != null ? String(r.exerciseId) : (r.exerciseName || 'unknown')
      if (!grouped[key]) {
        grouped[key] = {
          key,
          exerciseName: r.exerciseName || 'TracPatch Exercise',
          records: [],
        }
      }
      grouped[key].records.push(r)
    })
    return Object.values(grouped)
  }

  const fetchData = async (patientData) => {
    try {
      await props.fetchPatient(patientData._id)
      await props.getDeviceSchedule(patientData._id)
      const surveyScore = await props.getSurveyDetail(patientData._id)
      console.log('SURVEY SCORE', surveyScore)
      var data = await props.getFormData(patientData._id)
      setState({
        oks: data?.oks,
        pain: data?.pain,
        painLevel: data?.painLevel,
        flexion: data?.flexion,
        extension: data?.extension,
      })

      if (!_.isEmpty(surveyScore)) setSurveyDetail(surveyScore)

      // Fetch TracPatch ROM + Steps. Returns empty arrays for patients
      // who don't have TracPatch on their care plan, so this is safe to
      // call unconditionally — the Vitals renderer hides itself when
      // both arrays are empty.
      const tpData = await props.getTracPatchData(patientData._id)
      if (tpData) {
        setTracpatchData({ rom: tpData.rom || [], steps: tpData.steps || [] })
      }

      const tpExResults = await props.getTracpatchExerciseResults(patientData._id)
      setTracpatchExerciseGroups(
        groupTracpatchExerciseResults(tpExResults && tpExResults.data)
      )

      setSpin(false)
    } catch (error) {
      console.log(error)
      setSpin(false)
    }
  }
  const onFinish = async (otp) => {
    const status = await props.verifyActivityLinkOtp({
      ...otp,
      token: caregiverToken,
    })
    if (status) {
      //handleActivity(patientid);
      setShowActivity(true)
      setPatientId(patientid)
      setSpin(true)
      await props.fetchPatient(patientid)
      await props.getDeviceSchedule(patientid)
      const surveyScore = await props.getSurveyDetail(patientid)
      var data = await props.getFormData(patientid)
      setState({
        oks: data?.oks,
        pain: data?.pain,
        painLevel: data?.painLevel,
        flexion: data?.flexion,
        extension: data?.extension,
      })
      if (!_.isEmpty(surveyScore)) setSurveyDetail(surveyScore)

      const tpData = await props.getTracPatchData(patientid)
      if (tpData) {
        setTracpatchData({ rom: tpData.rom || [], steps: tpData.steps || [] })
      }

      const tpExResults = await props.getTracpatchExerciseResults(patientid)
      setTracpatchExerciseGroups(
        groupTracpatchExerciseResults(tpExResults && tpExResults.data)
      )

      setSpin(false)
    }
  }

  const otpPage = () => (
    // props.token != undefined ? (
    //   <Redirect to='/patient' />
    // ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' align='middle' className='signinrow-history center'>
          <Col span={24} flex='auto'>
            <div className='signinContainer'>
              <Card style={{ width: cardSize }}>
                <h2>Enter the OTP </h2>
                <p>
                  Activity Link? Please enter the OTP sent to your email address{' '}
                  {caregiveremail ?? caregiveremail}.
                </p>
                <Form
                  name='normal_login'
                  className='login-form'
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                >
                  <Row justify={'end'}>
                    <Col style={{ marginRight: 'auto' }} flex={'75%'}>
                      <Form.Item
                        name='otp'
                        rules={[
                          {
                            required: true,
                            message: 'Please input your Otp!',
                          },
                        ]}
                      >
                        <Input
                          prefix={
                            <UserOutlined className='site-form-item-icon' />
                          }
                          placeholder='Enter Your Otp'
                        />
                      </Form.Item>
                    </Col>
                    <Col flex={'20%'}>
                      <Form.Item>
                        <Button
                          style={{ width: '100%' }}
                          type='primary'
                          htmlType='submit'
                          className='login-form-button'
                        >
                          Send
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
                <Row style={{ marginTop: '1.5rem' }} justify='center'>
                  <Button
                    onClick={() => history.push('/login')}
                    type='primary'
                    htmlType='submit'
                    className='login-form-button'
                  >
                    Cancel
                  </Button>
                </Row>
              </Card>
            </div>
            {/* <Layout.Footer className="main-footer">{util.getCopyrightText()}</Layout.Footer> */}
          </Col>
        </Row>
      </Spin>
    </>
  )
  // )
  const sendIframe = (isOpen) => {
    window.parent.postMessage(isOpen, constants.APP_WEB_URL)
  }
  // const sendIframe = (isOpen) => {
  //   const event = new CustomEvent("iframeStatusChange", {
  //     detail: { type: "iframeStatusChange", data: isOpen }
  // });
  // console.log(JSON.stringify( window.parent.document),"xsssadsadasd",event)
  // window.parent.document.dispatchEvent(event);
  // }
  // const sendIframe = (isOpen) => {
  //   console.log("ddd")
  //   if (socket) {
  //     socket.send(JSON.stringify({ message: isOpen }));
  //   }
  // }

  const handleActivityOpen = () => {
    fullSizeActivity ? sendIframe(false) : sendIframe(true)
    setFullSizeActivity((prev) => !prev)
  }
  const handleMeasurementOpen = () => {
    fullScreenMeasurement ? sendIframe(false) : sendIframe(true)
    setFullScreenMeasurement((prev) => !prev)
  }

  const calculateWidth = () => {
    return isMobile ? size.width - size.width / 6 : size.width - size.width / 2
  }

  // Dedup TracPatch exercises within a day's `exercises[]` so a multi-slot
  // TracPatch master counts once (mirrors the patient app's
  // dedupTracPatchAcrossSlots in business/exercise.js — keep behavior in
  // sync). Standard exercises with the same exerciseid in different slots
  // are kept as separate instances; only TracPatch dedups.
  //
  // The `type` field lives on the master Exercise — `ex.meta.type` here.
  // (Patient app denormalizes it to `ex.type` via sync.service.js; admin
  // queries don't denormalize, so we read through `meta`.)
  const dedupTracPatchExercises = (exercises) => {
    if (!Array.isArray(exercises)) return []
    const seen = new Set()
    const out = []
    for (const ex of exercises) {
      if (!ex) continue
      const exType = ex.meta && ex.meta.type
      if (exType === 'TracPatch') {
        const id = String(ex.exerciseid || '')
        if (seen.has(id)) continue
        seen.add(id)
      }
      out.push(ex)
    }
    return out
  }

  // Count completed / total exercises for a single day's exercises[].
  // Returns { done, total }. Used by both the top bar (today's count)
  // and the VIEW modal (per-day rows).
  const countExercisesForDay = (exercises) => {
    const deduped = dedupTracPatchExercises(exercises)
    let done = 0
    for (const ex of deduped) {
      if (ex && ex.status === true) done++
    }
    return { done, total: deduped.length }
  }

  // Top bar now shows TODAY's exercises completed instead of "days where
  // all exercises were done this week" — matches what the patient sees in
  // their daily list and gives credit for partial-day progress
  // (e.g. 2 of 5 done today, not 0 of 7 days fully done).
  const renderExerciseCompliance = () => {
    const today = moment().startOf('day')
    const todayEntry =
      props.patientData?.exerciseSchedule?.exercisedateschedule?.find((d) =>
        moment(d.date).startOf('day').isSame(today)
      )
    const { done, total } = countExercisesForDay(todayEntry?.exercises)
    return renderVitalData(
      'Exercise',
      total === 0 ? 'NA' : `${done} of ${total}`,
      '-1',
      () => {
        setSelectedCompliance({ type: 'EXERCISE' })
        setComplianceOpen(true)
      }
    )
  }

  const renderMeasurementCompliance = () => {
    if (!props.patientData.include_devices) return
    let totalMeasurements = 0
    let totalCompleted = 0
    let currentWeekstart = moment().startOf('week')

    // The Measurement compliance row is for Tenovi-class measurement devices
    // only. TracPatch is treated as its own thing on the patient app
    // (separate Activities card, separate ROM Test compliance) so its
    // entries shouldn't inflate the Measurement totals here. Drop any
    // device whose display_name contains "tracpatch" (case-insensitive)
    // before reducing. If TracPatch is the only assigned device this leaves
    // totalMeasurements at 0 and the row falls through to its existing
    // "NA / hide" branch — exactly the desired behaviour for now. A proper
    // TracPatch compliance row is in slice 3 (post-demo).
    const isTracPatchDevice = (d) =>
      !!(d && d.display_name && String(d.display_name).toLowerCase().includes('tracpatch'))
    const nonTracPatchDevices = (devices) =>
      (devices || []).filter((d) => !isTracPatchDevice(d))

    let a = props.patientData?.deviceSchedule?.weeklydevice_summary?.forEach(
      (weekSummary) => {
        if (moment(weekSummary.weekdate).isBefore(currentWeekstart)) {
          const devices = nonTracPatchDevices(weekSummary?.devices)
          let deviceTotalDays = devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.totaldays
            },
            0
          )
          let deviceCompleted = devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.completeddays
            },
            0
          )
          totalMeasurements += deviceTotalDays
          totalCompleted += deviceCompleted
        }
      }
    )
    if (totalMeasurements != 0)
      return renderVitalData(
        'Measurement',
        totalMeasurements == 0
          ? 'NA'
          : parseFloat((totalCompleted / totalMeasurements) * 100).toFixed(2) +
              '%',
        '-1',
        () => {
          setSelectedCompliance({ type: 'MEASUREMENT' })
          setComplianceOpen(true)
        }
      )

    let b = props.patientData?.deviceSchedule?.weeklydevice_summary?.forEach(
      (weekSummary) => {
        if (moment(weekSummary.weekdate).isSame(currentWeekstart)) {
          const devices = nonTracPatchDevices(weekSummary?.devices)
          let deviceTotalDays = devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.totaldays
            },
            0
          )
          let deviceCompleted = devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.completeddays
            },
            0
          )
          totalMeasurements += deviceTotalDays
          totalCompleted += deviceCompleted
        }
      }
    )

    // Hide the Measurement row entirely when there's nothing to count
    // (e.g. TracPatch-only patients after the filter above) — the empty
    // "Measurement: NA" row was misleading.
    if (totalMeasurements === 0) return null

    return renderVitalData(
      'Measurement',
      `${totalCompleted} of ${totalMeasurements}`,
      '-1',
      () => {
        setSelectedCompliance({ type: 'MEASUREMENT' })
        setComplianceOpen(true)
      }
    )
  }

  // Count completed / total questionnaire forms for a single day's
  // forms[]. A form is "completed" when meta.complete is true. Returns
  // { done, total }. Shared by the top bar (today) and the VIEW modal
  // (per-day rows).
  // A form counts as "done" once it has been submitted. The server records
  // submission as `submittime` (set in getupdatedateschedule on the patient
  // feedback business layer) — it never populates the `meta.complete` flag the
  // UI originally checked, so that path always counted 0 and the row showed
  // 0.00% even after the patient completed (e.g.) their Pain Score. We also
  // accept a populated `answers` array as evidence of completion.
  const countFormsForDay = (forms) => {
    if (!Array.isArray(forms)) return { done: 0, total: 0 }
    let done = 0
    for (const f of forms) {
      if (!f) continue
      const submitted =
        !!f.submittime ||
        (Array.isArray(f.answers) && f.answers.length > 0) ||
        (f.meta && f.meta.complete)
      if (submitted) done++
    }
    return { done, total: forms.length }
  }

  // Top bar shows TODAY's questionnaire completion as a percentage
  // (mirrors the design ask: a quick "where am I today" number, with
  // the full per-day breakdown behind VIEW). Hidden entirely when there
  // are no forms scheduled today.
  const renderQuestionnaireCompliance = () => {
    const today = moment().startOf('day')
    const todayEntry =
      props.patientData?.feedbackSchedule?.feedbackdateschedule?.find((d) =>
        moment(d.date).startOf('day').isSame(today)
      )
    const { done, total } = countFormsForDay(todayEntry?.forms)
    const pctStr =
      total === 0 ? 'NA' : ((done / total) * 100).toFixed(2) + '%'
    return renderVitalData(
      'Questionnaire',
      pctStr,
      '-1',
      () => {
        setSelectedCompliance({ type: 'QUESTIONNAIRE' })
        setComplianceOpen(true)
      }
    )
  }

  const renderComplianceTable = (title, dataSource, dateColumnTitle) => {
    const columns = [
      {
        title: dateColumnTitle || 'Week Of',
        dataIndex: 'weekof',
        key: 'weekof',
        defaultSortOrder: 'descend',
        // Per-day rows pass a Date-like `sortDate`; weekly rows still
        // have weekof as a parseable date string. Sort by whichever is
        // present, falling back to the displayed text.
        sorter: (a, b) =>
          moment(a.sortDate || a.weekof) - moment(b.sortDate || b.weekof),
      },
      {
        title: 'Progress',
        dataIndex: 'compliance',
        key: 'compliance',
      },
    ]
    return (
      <>
        <h3>{title.toUpperCase()}</h3>
        <div>
          <Table
            dataSource={dataSource}
            columns={columns}
            showHeader
            bordered
            pagination={{ pageSize: 10, hideOnSinglePage: true, size: 'small' }}
            style={{ width: '80%', borderWidth: 2, padding: 10 }}
          />
        </div>
      </>
    )
  }

  // Per-day exercise compliance: one row per day from today back through
  // the schedule, showing "X of Y" exercises completed for that day plus
  // the week-of label so rows visually group by week. Future-dated days
  // are skipped (nothing to complete yet). Days with no scheduled
  // exercises are skipped too. TracPatch dedup matches the top-bar logic
  // so a multi-slot TracPatch master counts once per day.
  const renderExerciseComplianceData = () => {
    const data = []
    const today = moment().startOf('day')
    const schedule =
      props.patientData?.exerciseSchedule?.exercisedateschedule || []
    schedule.forEach((day) => {
      const dayDate = moment(day.date).startOf('day')
      if (dayDate.isAfter(today)) return
      const { done, total } = countExercisesForDay(day.exercises)
      if (total === 0) return
      const pct = total === 0 ? 0 : (done / total) * 100
      data.push({
        sortDate: dayDate.toISOString(),
        weekof: `${dayDate.format('ddd, MMM D')} `,
        compliance: `${done} of ${total} (${pct.toFixed(0)}%)`,
      })
    })
    return renderComplianceTable('Exercise — per day', data, 'Day')
  }

  // Per-day { date, done, total } completions for the Exercise VIEW line chart.
  // Same window / dedup rules as renderExerciseComplianceData, but returns raw
  // numbers (sorted ascending) instead of table rows.
  const getExerciseCompletionDaily = () => {
    const data = []
    const today = moment().startOf('day')
    const schedule =
      props.patientData?.exerciseSchedule?.exercisedateschedule || []
    schedule.forEach((day) => {
      const dayDate = moment(day.date).startOf('day')
      if (dayDate.isAfter(today)) return
      const { done, total } = countExercisesForDay(day.exercises)
      if (total === 0) return
      data.push({ date: dayDate.toDate(), done, total })
    })
    return data.sort((a, b) => a.date - b.date)
  }

  // Exercise VIEW content: a blue line of exercises completed per day, then one
  // yellow/green "% reps completed per day" line chart per TracPatch exercise.
  const renderExerciseComplianceCharts = () => {
    const daily = getExerciseCompletionDaily()
    return (
      <div style={{ width: '100%' }}>
        <ExerciseCompletionLineChart data={daily} />
        {tracpatchExerciseGroups.length > 0 && (
          <div style={{ marginTop: 24 }}>
            {tracpatchExerciseGroups.map((grp) => (
              <div key={grp.key} style={{ marginBottom: 24 }}>
                <TracPatchExerciseRepsLine
                  data={grp.records}
                  exerciseName={grp.exerciseName}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  const renderMeasurementComplianceData = () => {
    let data = []
    let currentWeekstart = moment().startOf('week')
    let a = props.patientData?.deviceSchedule?.weeklydevice_summary?.forEach(
      (weekSummary) => {
        if (moment(weekSummary.weekdate).isSameOrBefore(currentWeekstart)) {
          let deviceTotalDays = weekSummary?.devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.totaldays
            },
            0
          )
          let deviceCompleted = weekSummary?.devices.reduce(
            (prevVal, currentValue) => {
              return prevVal + currentValue.completeddays
            },
            0
          )
          data.push({
            weekof: weekSummary.weekdate,
            compliance:
              deviceTotalDays == 0
                ? 'NA'
                : `${deviceCompleted} of ${deviceTotalDays} (${parseFloat((deviceCompleted / deviceTotalDays) * 100).toFixed(2) + '%'})`,
          })
        }
      }
    )
    return renderComplianceTable('Measurement', data)
  }

  // Per-day questionnaire compliance for the VIEW modal — matches the
  // exercise modal: one row per day from the patient's earliest
  // scheduled form day through today, with the date plus "X of Y (Z%)".
  // Days with no forms scheduled are skipped; future days are skipped.
  const renderQuestionnaireComplianceData = () => {
    const data = []
    const today = moment().startOf('day')
    const schedule =
      props.patientData?.feedbackSchedule?.feedbackdateschedule || []
    schedule.forEach((day) => {
      const dayDate = moment(day.date).startOf('day')
      if (dayDate.isAfter(today)) return
      const { done, total } = countFormsForDay(day.forms)
      if (total === 0) return
      const pct = (done / total) * 100
      data.push({
        sortDate: dayDate.toISOString(),
        weekof: `${dayDate.format('ddd, MMM D')}`,
        compliance: `${done} of ${total} (${pct.toFixed(0)}%)`,
      })
    })
    return renderComplianceTable('Questionnaire — per day', data, 'Day')
  }

  /* const renderWeekDate = (date) => {
    let weekstart = moment(date).startOf('week');
    
    let exerciseData = props.patientData?.exerciseSchedule?.weeklyactivity_summary?.find((summary) => moment(summary.weekdate).isSame(weekstart,'day'))
    let exerciseCompliance = exerciseData ? (exerciseData?.completeddays/exerciseData?.totaldays) * 100 : 0;

    let deviceData = props.patientData?.deviceSchedule?.weeklydevice_summary?.find((summary) => moment(summary.weekdate).isSame(weekstart,'day'))
    let deviceTotalDays = deviceData?.devices.reduce((prevVal, currentValue) => {
      return prevVal + currentValue.totaldays
    },0);
    let deviceCompletedDays = deviceData?.devices.reduce((prevVal, currentValue) => {
      return prevVal + currentValue.completeddays
    },0);
    let deviceCompliance = (deviceCompletedDays / deviceTotalDays) * 100

    let feedbackData = props.patientData?.feedbackSchedule?.weeklyfeedschedule?.find((summary) => moment(summary.weekdate).isSame(weekstart,'day'))
    let feedbackTotalDays = feedbackData ? feedbackData?.feedback.reduce((prevVal, currentValue) => {
      return prevVal + currentValue.totaldays
    },0) : 0;
    let feedbackCompletedDays = feedbackData ? feedbackData?.feedback.reduce((prevVal, currentValue) => {
      return prevVal + currentValue.completeddays
    },0) : 0;
    let feedbackCompliance = feedbackTotalDays == 0 ? 0 : (feedbackCompletedDays / feedbackTotalDays) * 100

    let overallCompliance = (exerciseData?.completeddays + deviceCompletedDays + feedbackCompletedDays) / (exerciseData?.totaldays + deviceTotalDays + feedbackTotalDays) * 100;

    return exerciseData ? (
       <Row className='compliance'>         
          <Col span={12}>
            <p className="title">{'WEEK OF '}{weekstart.format('MM/DD')}</p>
            </Col>
          <Col span={12} className="row-last-col">
          <p className="title">COMPLIANCE: <b>{overallCompliance.toFixed(0)}%</b></p>
          </Col>

          <div className="line"></div>

          <Col span={12} >
          <p className="title detail">EXERCISE</p>
          </Col>
          <Col span={8} >
          <p className="title detail">{exerciseData.completeddays} OF {exerciseData.totaldays}</p>
          </Col>
          <Col span={4} className="row-last-col">
          <p className="title detail"><b>{ exerciseCompliance.toFixed(0) }%</b></p>
          </Col>

          <Col span={12} >
          <p className="title detail">MEASUREMENTS</p>
          </Col>
          <Col span={8} >
          <p className="title detail">  { deviceTotalDays != 0 ? `${deviceCompletedDays} OF ${deviceTotalDays}` : 'N/A' }</p>
          </Col>
          <Col span={4} className="row-last-col">
          <p className="title detail"><b>{ deviceTotalDays != 0 ? deviceCompliance.toFixed(0) + '%' : '' } </b></p>
          </Col>

          
          <Col span={12} >
          <p className="title detail">QUESTIONNAIRE</p>
          </Col>
          <Col span={8} >
          <p className="title detail">{ feedbackTotalDays != 0 ? `${feedbackCompletedDays} OF ${feedbackTotalDays}` : 'N/A' }</p>
          </Col>
          <Col span={4} className="row-last-col">
          <p className="title detail"><b>{ feedbackTotalDays != 0 ? feedbackCompliance.toFixed(0) + '%' : '' }</b></p>
          </Col> 
       </Row> 
    ) : (<></>)
  }
 */
  const renderCompliance = () => (
    <>
      <Row className='row-header'>
        <Row className='activityLabel'>
          <p>Progress</p>
        </Row>
      </Row>
      {/*Rendering last 4 weeks */}
      {/* {[0,1,2,3].map( (number) => renderWeekDate(moment().subtract(number,'weeks')) )}  */}
      {renderExerciseCompliance()}
      {renderMeasurementCompliance()}
      {renderQuestionnaireCompliance()}
    </>
  )

  const getBMI = (height, weight) => {
    return parseFloat(
      (weight / (parseFloat(height) * parseFloat(height))) * 703
    ).toFixed(2)
  }
  // TracPatch vitals — latest active ROM test (flexion / extension) and
  // today's step total. Renders nothing when the patient has no TracPatch
  // data, so non-TracPatch patients see no change in this section.
  const renderTracPatchVitals = () => {
    const rom = tracpatchData?.rom || []
    const steps = tracpatchData?.steps || []
    if (!rom.length && !steps.length) return null

    // Pick the latest record. Prefer is_rom_test:true (an active, guided
    // ROM Test from the patient app) over passive device events. Falls
    // back to the most recent record from any source.
    const sortedRom = [...rom].sort((a, b) => {
      return (
        new Date(b?.startTime || b?.timestamp || 0).getTime() -
        new Date(a?.startTime || a?.timestamp || 0).getTime()
      )
    })
    const latestActive = sortedRom.find((r) => r && r.is_rom_test === true)
    const latest = latestActive || sortedRom[0]

    // Sum steps recorded with a startTime falling on today's local date.
    const todayStart = moment().startOf('day').valueOf()
    const todayEnd = moment().endOf('day').valueOf()
    const stepsToday = steps.reduce((sum, s) => {
      const t = new Date(s?.startTime || s?.timestamp || 0).getTime()
      return t >= todayStart && t <= todayEnd ? sum + (s?.steps || 0) : sum
    }, 0)

    const fmtDeg = (v) =>
      v === undefined || v === null ? undefined : `${Math.round(v)}°`

    return (
      <>
        {latest && latest.flexion !== undefined && latest.flexion !== null && (
          renderVitalData(
            'Flexion',
            fmtDeg(latest.flexion),
            latest.startTime,
            () => {
              setSelectedActivity('FLEXION')
              setActivityOpen(true)
            },
            true
          )
        )}
        {latest && latest.extension !== undefined && latest.extension !== null && (
          renderVitalData(
            'Extension',
            fmtDeg(latest.extension),
            latest.startTime,
            () => {
              setSelectedActivity('EXTENSION')
              setActivityOpen(true)
            },
            true
          )
        )}
        {steps.length > 0 && (
          renderVitalData(
            'Steps Today',
            stepsToday.toLocaleString(),
            new Date(),
            () => {
              setSelectedActivity('STEPS')
              setActivityOpen(true)
            },
            true
          )
        )}
      </>
    )
  }

  const renderVitals = () => (
    <>
      <Row className='row-header'>
        <Row className='activityLabel'>
          <p>Activities</p>
        </Row>
      </Row>
      {console.log('PATIENT DATA', props.patientData)}

      {renderTracPatchVitals()}

      {!_.isEmpty(surveyDetail) &&
        surveyDetail.forms.map((form) => handleFormSwitch(form, surveyDetail))}

      {!_.isEmpty(props.patientData?.deviceSchedule?.assigneddevices) &&
        props.patientData?.deviceSchedule?.assigneddevices.map((device) => {
          if (device.isDeleted) return null
          let score = props.patientData?.deviceSchedule?.lastscore.find(
            (sc) => sc.deviceid == device.deviceid
          )
          //let deviceGroup = device.valueDesc.groupby((dev) => dev.metric);
          let deviceGroup = _.chain(device.valueDesc).groupBy('metric')
          //console.log("DEVICE GROUP", deviceGroup)
          return deviceGroup
            .map((parameters, key) => {
              //console.log("DEVICE GROUP param", parameters, key,score.value)
              let idx = score.device_metric.indexOf(key)
              let val = ''
              if (idx == -1) {
                parameters.forEach((parameter) => {
                  let paramValue = score.value[parameter.valueIndex]
                  val = val + (paramValue ? paramValue + '/' : '')
                  //console.log(val);
                })
                val = val.substring(0, val.length - 1)
              } else {
                val = score.value[idx]
              }
              let addData =
                val && key.toUpperCase() == 'WEIGHT'
                  ? props.patientData.height
                    ? '(BMI: ' + getBMI(props.patientData.height, val) + ')'
                    : ''
                  : ''
              val = val
                ? val /*+ ' ' + parameters[0].unit*/ + ` ${addData}`
                : val
              if (val) {
                //let val = score.value[parameter.valueIndex]
                if (key == 'peak_expiratory_flow') key = 'peak_exp_flo'
                if (key == 'forced_expiratory_volume') key = 'forced_exp_vol'
                return renderVitalData(key, val, score.date, () => {
                  //let val = score.value[parameter.valueIndex]
                  setSelectedDevice({
                    ...device,
                    metric_name: key,
                    type: 'DEVICE',
                    parameter: parameters[0].parameter,
                  })
                  setGraphOpen(true)
                })
              } else {
                return renderVitalData(key, undefined, undefined, () => {})
              }
            })
            .value()
          /*return device.valueDesc.map(parameter => {
            if(score)
            {
              let val = score.value[parameter.valueIndex]
              return renderVitalData(parameter.metric, val ? val  + ' ' + parameter.unit : undefined, score.date,
                () => {
                  setSelectedDevice({...device, metric_name: parameter.metric, type: "DEVICE" });
                  setGraphOpen(true);
                }
                )
            } else {
              return renderVitalData(parameter.metric, undefined, undefined, () => {}  )
            }
        })*/
        })}
    </>
  )

  const renderQuestionnaires = () => (
    <>
      <Row className='row-header'>
        <Row className='activityLabel'>
          <p>QUESTIONNAIRES</p>
        </Row>
      </Row>
      {console.log('PATIENT DATA', props.patientData)}
      {!_.isEmpty(surveyDetail) &&
        surveyDetail.forms.map((form) => handleFormSwitch(form, surveyDetail))}
      {!_.isEmpty(props.patientData?.deviceSchedule?.lastscore) &&
        props.patientData?.deviceSchedule?.lastscore.map((score) =>
          renderVitalData(
            score.device_metric[0],
            score.value[0] + ' ' + score.device_unit[0],
            score.date,
            () => {
              let dev = props.patientData?.deviceSchedule?.assigneddevices.find(
                (dev) => dev.deviceid == score.deviceid
              )
              setSelectedDevice({ ...dev, metric_name: score.device_metric[0] })
              setGraphOpen(true)
            }
          )
        )}
    </>
  )

  const renderFeedbackForms = () => (
    <>
      <Row className='row-header'>
        <Row className='activityLabel'>
          <p>Questionnaires</p>
        </Row>
      </Row>
      {!_.isEmpty(surveyDetail) &&
        surveyDetail.forms.map((form) => handleFormDisplay(form, surveyDetail))}
    </>
  )

  // Open the questionnaire's chart (like the admin) when its VIEW button is
  // clicked. Routes by shortname into the existing graph modal; questionnaires
  // without a wired chart fall back to the form viewer.
  const handleQuestionnaireView = (shortname) => {
    switch (shortname) {
      case constants.SCORE.KNEE_SCORE:
        setSelectedDevice({ type: constants.SCORE.KNEE_SCORE })
        setGraphOpen(true)
        break
      case constants.SCORE.PAIN_LEVEL:
        // 'Pain Management' → the categorical Pain Level chart (state.painLevel).
        setSelectedDevice({ type: constants.SCORE.PAIN_LEVEL })
        setGraphOpen(true)
        break
      case 'Pain Score':
        // 'Pain Score' (0-10 NRS) → its own 0-10 chart (state.pain).
        setSelectedDevice({ type: 'Pain Score' })
        setGraphOpen(true)
        break
      case constants.SCORE.FLEXION:
        // 'Range Of Motion' is one questionnaire covering BOTH flexion and
        // extension, so show both charts (the Activities section still has its
        // own separate Flexion / Extension rows).
        setSelectedDevice({ type: 'ROM' })
        setGraphOpen(true)
        break
      default:
        handleSurveyForm(shortname)
    }
  }

  const handleFormDisplay = (mainform, surveyDetail) => {
    // Last-recorded date: the most recent day this form was submitted.
    let lastreported = null
    surveyDetail.feedbackdateschedule.forEach((schedule) => {
      schedule.forms.forEach((form) => {
        if (form.formid == mainform.formid && form.answers.length > 0) {
          if (
            lastreported == null ||
            moment(lastreported).isBefore(moment(form.submittime))
          ) {
            lastreported = form.submittime
          }
        }
      })
    })

    // Last result. The authoritative per-questionnaire score is on the
    // TOP-LEVEL lastscores form (`mainform.score`) — NOT on the per-day
    // feedbackdateschedule entries, whose `score` is always the placeholder
    // '0' (the server never writes it). 'Pain Score' is the exception: it isn't
    // scored into getSurveyDetail at all, so its latest value comes from the
    // pain-score series (state.pain, the same data the Pain chart plots).
    let value
    if (lastreported == null) {
      value = undefined
    } else if (mainform.shortname === 'Pain Score') {
      value =
        Array.isArray(state.pain) && state.pain.length > 0
          ? state.pain[state.pain.length - 1].score
          : ''
    } else {
      value =
        mainform.score !== undefined && mainform.score !== null
          ? mainform.score
          : ''
    }

    return renderVitalData(
      mainform.shortname,
      value,
      lastreported,
      () => handleQuestionnaireView(mainform.shortname),
      true
    )
  }

  const getGraphDateWithYear = (dateStr) => {
    try {
      if (!dateStr && dateStr.split(' ') < 2) return null

      const year = moment().year()
      const arr = dateStr.split(' ') // 09/17 Mor
      const combinedDate = `${arr[0]}/${year}`
      const formattedDate = moment(combinedDate)
      return formattedDate.format('MM/DD/YYYY')
    } catch (err) {
      console.log('Error in date formatting', dateStr)
    }
    return null
  }

  const sanatizeGraphData = (data) => {
    let sanatizedData = []
    if (_.isEmpty(data)) return sanatizedData
    const { values } = data[0]
    const today = moment()
    // remove days that does not have measurement
    // no future dates required
    sanatizedData = values.map((value, idx) => {
      const datefilter = getGraphDateWithYear(value.x)
      if (!_.isEmpty(value.y) && !util.isAfter(today, datefilter)) {
        return value
      }
    })
    return _.reverse(_.compact(data[0].values))
  }

  /* const viewTable = () => (
    <div ref={ref} className="bordered-container" >
      <Table
        columns={columns}
        dataSource={sanatizeGraphData(graphData.data)}
        showHeader
        scroll={{y:200}}
        bordered
        pagination={false}
        style={{ height: '250px', width: '100%', borderWidth: 1 }}
      />
    </div>
  ) */

  const hasCommonWord = (str1, str2) => {
    // Split both strings into arrays of words
    const words1 = str1.toLowerCase().split(' ')
    const words2 = str2.toLowerCase().split(' ')

    // Check if any word in words1 exists in words2
    return words1.some((word) => words2.includes(word))
  }

  const handleSurveyForm = (name) => {
    const data = surveyDetail.forms.find((form) =>
      hasCommonWord(name, form.shortname)
    )
    if (data) {
      setFormType(data.shortname)
      setFormOpen(true)
    }
  }

  const renderVitalData = (key, value, date, clickCallback, showView = false) => {
    // The VIEW button renders for compliance bars (date === '-1') and for any
    // row that explicitly opts in via showView (e.g. the TracPatch Flexion /
    // Extension / Steps rows, which keep their real "Last Recorded" date AND
    // get a VIEW button).
    const renderView = date === '-1' || showView
    return (
      <Row
        className='vital-value'
        onClick={value == undefined ? '' : clickCallback}
      >
        <Col span={17}>
          <p
            className='heading'
            style={date != '-1' ? {} : { lineHeight: '2em' }}
          >
            {key.replaceAll('_', ' ').toUpperCase()}{' '}
            <b>
              {value !== undefined && value !== null && value !== ''
                ? ': ' + value
                : ''}
            </b>
          </p>
          {date != '-1' && (
            <p className='footer'>
              Last Recorded{' '}
              {date ? moment(date).format('MM/DD/YYYY') : 'N/A'}{' '}
            </p>
          )}
        </Col>
        <Col span={7} className='row-last-col'>
          {/* VIEW shows on the Progress compliance bars (caller passes
              date === '-1') and on any vital row that opts in via
              showView — the TracPatch rows plus the Knee Score / Pain
              Level / Flexion / Extension questionnaire rows. Other
              device rows keep just the row click for their graph. */}
          {renderView && (
            <Button
              className={value == undefined ? 'buttonDisabled' : 'button'}
              type='primary'
              disabled={value == undefined}
              onClick={(e) => {
                e.stopPropagation()
                if (value != undefined && clickCallback) clickCallback()
              }}
            >
              VIEW
            </Button>
          )}
        </Col>
      </Row>
    )
  }

  const renderRow = (key, value, date) => {
    return (
      <>
        <Col flex='60%' className='survey-name'>
          <Row>{key}</Row>
          <Row style={{ fontSize: '12px', padding: '2px' }}>
            <span>
              {`Last reported on `}
              {date ? <i>{moment(date).format('MM/DD/YYYY')}</i> : 'NA'}
            </span>
          </Row>
        </Col>
        <Col className='survey-score' flex='40%'>
          {value || (typeof value == 'number' && value == 0) ? value : 'NA'}
        </Col>
      </>
    )
  }

  const handleFormSwitch = (form, lastscores) => {
    //console.log(lastscores, form, "FORM")
    switch (form.shortname) {
      case constants.SCORE.KNEE_SCORE:
        return renderVitalData(
          constants.SCORE.KNEE_SCORE_v2,
          lastscores?.kneescore !== undefined && lastscores?.kneescore !== null
            ? lastscores?.kneescore
            : undefined,
          lastscores?.kneescore !== undefined && lastscores?.kneescore !== null
            ? lastscores?.kneescoredate
            : undefined,
          () => {
            setSelectedDevice({ type: constants.SCORE.KNEE_SCORE })
            setGraphOpen(true)
          },
          true
        )
      case constants.SCORE.PAIN_LEVEL:
        return renderVitalData(
          constants.SCORE.PAIN_LEVEL_V2,
          lastscores?.painlevel ? lastscores?.painlevel : undefined,
          lastscores?.painlevel ? lastscores?.painleveldate : undefined,
          () => {
            setSelectedDevice({ type: constants.SCORE.PAIN_LEVEL })
            setGraphOpen(true)
          },
          true
        )
      case constants.SCORE.FLEXION:
        return (
          <div className='weight-row' style={{ display: 'contents' }}>
            {renderVitalData(
              constants.SCORE.FLEXION_V2,
              lastscores?.flexion ? lastscores?.flexion : undefined,
              lastscores?.flexion ? lastscores?.flexiondate : undefined,
              () => {
                setSelectedDevice({ type: constants.SCORE.FLEXION })
                setGraphOpen(true)
              },
              true
            )}
            {/* <Row style={{ width:'100%'}}> */}
            {renderVitalData(
              constants.SCORE.EXTENSION,
              lastscores?.extension ? lastscores?.extension : undefined,
              lastscores?.extension ? lastscores?.extensiondate : undefined,
              () => {
                setSelectedDevice({ type: constants.SCORE.EXTENSION })
                setGraphOpen(true)
              },
              true
            )}
            {/* </Row> */}
          </div>
        )
    }
  }

  const renderForm = (lastscores, form) => {
    return (
      <Row
        onClick={() => handleSurveyForm(form.shortname)}
        style={{
          maxHeight:
            form.shortname == constants.SCORE.FLEXION ? '130px' : '60px',
        }}
      >
        {handleFormSwitch(form, lastscores)}
      </Row>
    )
  }

  const surveyReading = () => (
    <Col>
      <Row className='row-header'>
        <Col className='activityLabel '>
          <p>Survey Completed</p>
        </Col>
      </Row>
      <Row className='bordered-container' style={{ flexDirection: 'column' }}>
        {surveyDetail.forms.map((form) => renderForm(surveyDetail, form))}
      </Row>
    </Col>
  )

  // Checking
  const renderFormModal = () => (
    <Modal
      className={'formModal '}
      destroyOnClose={true}
      visible={formOpen}
      footer={false}
      width={'90vw'}
      onCancel={() => setFormOpen(false)}
    >
      <PatientForm type={formType} />
    </Modal>
  )

  const renderGraphModal = () => (
    <Modal
      className={'formModal'}
      destroyOnClose={true}
      closable={false}
      visible={graphOpen}
      footer={false}
      width={'98vw'}
      onCancel={() => setGraphOpen(false)}
    >
      <div className='chartDiv'>
        <center>
          {selectedDevice.type == 'DEVICE' && (
            <DeviceGraph
              isLoading={(e) => {}}
              dev={{ ...selectedDevice, patientid: patientData._id }}
              showTable={true}
              width={cardSize}
              hideBorder={true}
            />
          )}
          {selectedDevice.type == constants.SCORE.KNEE_SCORE && (
            <Oks
              data={state.oks}
              onClick={() => {}}
              fullscreen={true}
              showtips
              showTable={true}
              width={cardSize}
            />
          )}
          {selectedDevice.type == constants.SCORE.PAIN_LEVEL && (
            <Pain
              data={state.painLevel}
              onClick={() => {}}
              fullscreen={true}
              showtips
              showTable={true}
              width={cardSize}
            />
          )}
          {selectedDevice.type == 'Pain Score' && (
            <TracPatchPainScoreChart data={state.pain} />
          )}
          {selectedDevice.type == constants.SCORE.FLEXION && (
            <Flexion
              data={state.flexion}
              onClick={() => {}}
              fullscreen={true}
              showtips
              showTable={true}
              width={cardSize}
            />
          )}
          {selectedDevice.type == constants.SCORE.EXTENSION && (
            <Extension
              data={state.extension}
              onClick={() => {}}
              fullscreen={true}
              showtips
              showTable={true}
              width={cardSize}
            />
          )}
          {/* 'Range Of Motion' questionnaire — flexion AND extension stacked. */}
          {selectedDevice.type == 'ROM' && (
            <>
              <Flexion
                data={state.flexion}
                onClick={() => {}}
                fullscreen={true}
                showtips
                showTable={true}
                width={cardSize}
              />
              <Extension
                data={state.extension}
                onClick={() => {}}
                fullscreen={true}
                showtips
                showTable={true}
                width={cardSize}
              />
            </>
          )}
        </center>
      </div>
      <div style={{ textAlign: 'center', paddingTop: 16, paddingBottom: 24 }}>
        <Button
          type='primary'
          style={{ width: 200 }}
          onClick={() => setGraphOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  )

  const renderComplianceModal = () => (
    <Modal
      className={'formModal'}
      destroyOnClose={true}
      closable={false}
      visible={complianceOpen}
      footer={false}
      width={'98vw'}
      onCancel={() => setComplianceOpen(false)}
    >
      <div className='chartDiv'>
        <center>
          {selectedCompliance.type == 'EXERCISE' &&
            renderExerciseComplianceCharts()}
          {selectedCompliance.type == 'MEASUREMENT' &&
            renderMeasurementComplianceData()}
          {selectedCompliance.type == 'QUESTIONNAIRE' &&
            renderQuestionnaireComplianceData()}
        </center>
      </div>
      <div style={{ textAlign: 'center', paddingTop: 16, paddingBottom: 24 }}>
        <Button
          type='primary'
          style={{ width: 200 }}
          onClick={() => setComplianceOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  )

  const renderActivityModal = () => (
    <Modal
      className={'formModal'}
      destroyOnClose={true}
      closable={false}
      visible={activityOpen}
      footer={false}
      width={'98vw'}
      onCancel={() => setActivityOpen(false)}
    >
      <div className='chartDiv'>
        <center>
          {selectedActivity === 'FLEXION' && (
            <TracPatchFlexionChart data={tracpatchData.rom} />
          )}
          {selectedActivity === 'EXTENSION' && (
            <TracPatchExtensionChart data={tracpatchData.rom} />
          )}
          {selectedActivity === 'STEPS' && (
            <TracPatchStepsChart data={tracpatchData.steps} />
          )}
        </center>
      </div>
      <div style={{ textAlign: 'center', paddingTop: 16, paddingBottom: 24 }}>
        <Button
          type='primary'
          style={{ width: 200 }}
          onClick={() => setActivityOpen(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  )

  const renderActivityDrawer = () => (
    <Drawer
      placement='right'
      closable={false}
      visible={fullSizeActivity}
      bodyStyle={{ padding: 0 }}
      // className='linegraphdata'
      width='100vw'
      height='100vh'
    >
      <Row
        onClick={handleActivityOpen}
        style={{ fontSize: '24px', paddingRight: '10%' }}
        align='end'
        className='cancel-zoom'
      >
        <CloseOutlined />
      </Row>
      <Row className='linegraphdata ' justify='center'>
        <Row className='activiies-max-div'>
          {exercisesArray?.data && (
            <ActivityGraph
              data={exercisesArray.data}
              width={size.height - size.height / 4}
              summary={exercisesArray.summary}
              isrotate={true}
            />
          )}
        </Row>
      </Row>
    </Drawer>
  )

  const renderMeasurementDrawer = () => (
    <Drawer
      placement='right'
      closable={false}
      visible={fullScreenMeasurement}
      bodyStyle={{ padding: 0 }}
      className='iframe-drawer'
      width='100vw'
      height='100vh'
    >
      <Row
        onClick={handleMeasurementOpen}
        style={{ fontSize: '24px', paddingRight: '10%' }}
        align='end'
        className='cancel-zoom'
      >
        <CloseOutlined />
      </Row>
      <div className='linegraphdata '>
        <Row className='activiies-max-div'>
          {!_.isEmpty(graphData) && (
            <LineGraph
              data={graphData}
              width={size.height - size.height * 0.1}
              height={size.width - size.width * 0.5}
              isrotate={true}
            />
          )}
        </Row>
      </div>
    </Drawer>
  )
  const handleShare = () => {
    setShareModal(true)
  }
  const handleConfirm = async (data) => {
    const response = await props.caregiverNotify({
      patientid: patientId,
      email: data.email,
      name: data.name,
    })
    if (response.status == constants.MESSAGE.SUCCESS) setShareModal(false)
  }
  const renderShareModal = () => {
    const { phone, email, caregiver, email_opt_in } = props.patientData
    return (
      <Modal
        visible={shareModal}
        footer={false}
        onCancel={() => setShareModal(false)}
        className='shareModal'
        centered
        width={300}
      >
        <Caregiver
          isLoading={props.isLoading}
          patientPhone={phone}
          patientEmail={email}
          caregiver={caregiver}
          email_opt_in={email_opt_in}
          handleConfirm={handleConfirm}
          closeModal={() => setShareModal(false)}
        />
      </Modal>
    )
  }
  const handleNavigate = async (path) => {
    await history.push({ pathname: path, search: constants.ADMIN_LITE })
    if (!window.ReactNativeWebView) return
    await window.ReactNativeWebView.postMessage(
      JSON.stringify({
        route: '/navigate',
        data: { path },
      })
    )
  }
  const handleBack = () => {
    let path = location.state.pathName
    handleNavigate(path)
  }
  const renderActivities = () => (
    <>
      <Spin spinning={spin || props.isLoading}>
        <div className='activity-page-container'>
          <div className='activity-page '>
            <Row className='activityHeader'>
              <Col span={12}>Progress</Col>
              <Col span={12} className='row-last-col'>
                {!isAdminLite ? (
                  <Button
                    className='button'
                    type='primary'
                    icon={<ShareAltOutlined />}
                    onClick={handleShare}
                  >
                    SHARE
                  </Button>
                ) : (
                  <Button
                    className='button'
                    type='primary'
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                )}
              </Col>
            </Row>
            <div className='activity-max-container'>
              <Row className='antcolumn' justify='center'>
                <Col flex='100%'> {renderVitals()}</Col>
                <Col flex='100%'> {renderCompliance()}</Col>
                <Col flex='100%'> {renderFeedbackForms()}</Col>
                {/* <Col flex="100%">{!_.isEmpty(props.assignedDevices) && renderMeasurement()}</Col>
              <Col flex="100%" > {!_.isEmpty(surveyDetail) && surveyReading()}</Col> */}
              </Row>
            </div>
            {renderGraphModal()}
            {renderFormModal()}
            {renderComplianceModal()}
            {renderActivityModal()}
          </div>
        </div>
      </Spin>
    </>
  )

  const renderContent = () => {
    return (
      <>
        {!showActivity && otpPage()}
        {showActivity && renderActivities()}
        {shareModal && renderShareModal()}
        {fullSizeActivity && renderActivityDrawer()}
        {fullScreenMeasurement &&
          !_.isEmpty(props.assignedDevices) &&
          renderMeasurementDrawer()}
      </>
    )
  }

  return (
    <>
      {isMobile ? (
        renderContent()
      ) : (
        <Layout
          style={{
            padding: '0 0 0 0',
            height: '100vh',
            backgroundColor: '#DDDDDD',
          }}
        >
          <>
            {caregiverToken != null ? <Menubar token={caregiverToken} /> : null}
            <Content style={{ overflow: 'auto', background: 'white' }}>
              {renderContent()}
            </Content>
            <Footer className='main-footer'>{util.getCopyrightText()}</Footer>
          </>
        </Layout>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    hasError: state.profile.error,
    message: state.profile.message,
    isLoading: state.patient.isLoading,
    // token: util.verifyToken(state.profile.token),
    assignedDevices: state.device.assignedDevices,
    patientData: state.patient.patient,
    token: util.verifyToken(state.profile?.token),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (id) => dispatch(getPatient(id)),
    verifyActivityLinkOtp: (data) => dispatch(verifyActivityLinkOtp(data)),
    validPatientId: (data) => dispatch(validPatientId(data)),
    getRangeExercises: (data) => dispatch(getRangeExercises(data)),
    getDeviceSchedule: (patientid) => dispatch(getDeviceSchedule(patientid)),
    getSurveyDetail: (patientid) => dispatch(getSurveyDetail(patientid)),
    getRangeMeasurement: (data) => dispatch(getRangeMeasurement(data)),
    getFormData: (id) => dispatch(getFormData(id)),
    caregiverNotify: (data) => dispatch(caregiverNotify(data)),
    getTracPatchData: (id) => dispatch(getTracPatchData(id)),
    getTracpatchExerciseResults: (id) => dispatch(getTracpatchExerciseResults(id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Activities)
